var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArraySchema, Schema, type } from "@colyseus/schema";
/**
 * One labelled group of detail lines on a `HistoryEntry` — the synced mirror of
 * the `ActionNoticeGroup` shape (e.g. a market cycle's `Removed` / `Cycled In`
 * lists). Kept as its own schema so the `items` array syncs incrementally.
 */
export class HistoryGroup extends Schema {
    constructor() {
        super(...arguments);
        /** Group heading, e.g. "Removed" or "Cycled In". */
        this.label = "";
        /** Lines under the heading (card or building names, etc.). */
        this.items = new ArraySchema();
    }
}
__decorate([
    type("string")
], HistoryGroup.prototype, "label", void 0);
__decorate([
    type(["string"])
], HistoryGroup.prototype, "items", void 0);
/**
 * One recorded action in the match's move history (the synced backing for the
 * sidebar's Turn History view). Mirrors the broadcast `ActionNotice`, plus the
 * round/turn it happened on and a snapshot of the actor's name/seat so the
 * entry still renders correctly after that player leaves. `id` is a monotonic
 * server sequence for stable client keys (entries can be dropped off the front
 * once the history is capped).
 */
export class HistoryEntry extends Schema {
    constructor() {
        super(...arguments);
        /** Monotonic id assigned by the server — stable across history trimming. */
        this.id = 0;
        /** Session id of the player who acted. */
        this.playerId = "";
        /** The actor's display name, snapshotted so it survives them leaving. */
        this.playerName = "";
        /** The actor's seat, snapshotted — drives the seat colour in the list. */
        this.seat = 0;
        /** Short headline, e.g. "Cycle 2 Cards" or "Build Scout". */
        this.title = "";
        /** Round the action was taken in. */
        this.round = 0;
        /** Turn (global turn counter) the action was taken in. */
        this.turn = 0;
        /** Board node the action centred on (e.g. the built node), or `-1` for none.
         * Drives the Turn History "click to pan/zoom the board to this action". */
        this.focusNodeId = -1;
        /** Optional detail groups shown beneath the title. */
        this.groups = new ArraySchema();
    }
}
__decorate([
    type("uint32")
], HistoryEntry.prototype, "id", void 0);
__decorate([
    type("string")
], HistoryEntry.prototype, "playerId", void 0);
__decorate([
    type("string")
], HistoryEntry.prototype, "playerName", void 0);
__decorate([
    type("uint8")
], HistoryEntry.prototype, "seat", void 0);
__decorate([
    type("string")
], HistoryEntry.prototype, "title", void 0);
__decorate([
    type("uint16")
], HistoryEntry.prototype, "round", void 0);
__decorate([
    type("uint16")
], HistoryEntry.prototype, "turn", void 0);
__decorate([
    type("int32")
], HistoryEntry.prototype, "focusNodeId", void 0);
__decorate([
    type([HistoryGroup])
], HistoryEntry.prototype, "groups", void 0);
//# sourceMappingURL=MoveHistory.js.map